const Resources = {

    table_headers: [  
        {
            text: 'Bed code',
            value: 'bed_code'
        },
        {
            text: 'Daily Assignment',
            value: 'daily_assignment'
        },
        {
            text: 'Associate',
            value: 'associate'
        },

    ],
    
    breadcrumb:[
        {
            name: 'Home',
            href: '/',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Discharged Beds',
            href: '/discharge-beds',
            arrow: "",
        },
    ],
    
    excel_file_headers: {
        'Code': 'code',
    },

    empty_format_data: [
        {
            code: '',
        },
    ]

}

export default Resources;